export const EMPTY_REPORT_VIEW_MORE_MODAL = {
  isOpen: false,
  reportId: null,
  widget: null,
};
